import { useQuery, useReactiveVar } from "@apollo/client";
import { useState } from "react";
import {
  GetReviewChatSessionIdQuery,
  GetReviewChatSessionIdQueryVariables,
} from "types/graphql-schema";

import AskAI from "@apps/ask-ai/ask-ai";
import {
  ChatSessionContext,
  PageContextMessage,
} from "@apps/ask-ai/ask-ai-context";
import getReviewChatSessionId from "@apps/ask-ai/graphql/get-review-chat-session-id";
import Loading from "@components/loading/loading";

import { assessmentContextSidebarVar } from "./context-sidebar/context-sidebar-context";
import CompleteInAiTool from "./review-ai-tool/complete-in-ai-tool";
import { ReviewForAiTool } from "./review-ai-tool/review-ai-tool";

const AssessmentAskAI = ({
  assessmentId,
  chatSessionId,
  startedChatSession,
  onChangeChatSessionId,
  onStartChatSession,
  aiToolReview,
  pageContextMessage,
}: {
  assessmentId?: number;
  startedChatSession: boolean;
  chatSessionId: number | null;
  onChangeChatSessionId: (chatSessionId: number | null) => void;
  onStartChatSession: () => void;
  aiToolReview?: ReviewForAiTool | null;
  pageContextMessage?: PageContextMessage;
}) => {
  const assessmentContextSidebar = useReactiveVar(assessmentContextSidebarVar);
  const focus =
    assessmentContextSidebar?.assessmentId === assessmentId
      ? assessmentContextSidebar
      : null;
  const questionId = focus?.questionId;

  const [
    currentSuggestedAssessmentResponseId,
    setCurrentSuggestedAssessmentResponseId,
  ] = useState<string | null>(null);

  const { data, loading, error } = useQuery<
    GetReviewChatSessionIdQuery,
    GetReviewChatSessionIdQueryVariables
  >(getReviewChatSessionId, {
    variables: { assessmentId: assessmentId! },
    skip: !assessmentId || !!chatSessionId,
    fetchPolicy: "network-only",
  });
  const sessionId = chatSessionId ?? data?.reviewChatSessionId ?? null;

  if (assessmentId && !chatSessionId && (loading || error)) {
    return error ? (
      <div role="alert" className="p-6">
        {error.message}
      </div>
    ) : (
      <Loading className="p-6">Opening conversation...</Loading>
    );
  }
  return (
    <ChatSessionContext.Provider
      value={{
        assessmentId,
        pageContextMessage,
        assessmentQuestionId: questionId,
        currentSuggestedAssessmentResponseId,
        setCurrentSuggestedAssessmentResponseId,
      }}
    >
      <div className="flex-1 flex flex-col">
        <AskAI
          pendingPromptTarget={
            focus ? `review-${assessmentId}-question-${questionId}` : undefined
          }
          isInSidebar={true}
          chatSessionId={sessionId}
          onChangeChatSessionId={onChangeChatSessionId}
          onStartChatSession={onStartChatSession}
          isFullScreen={!!sessionId || startedChatSession}
          className="px-6 pb-6"
          totalYPaddingAroundContainer={110}
          emptyStateCta={
            aiToolReview && <CompleteInAiTool review={aiToolReview} />
          }
        />
      </div>
    </ChatSessionContext.Provider>
  );
};

export default AssessmentAskAI;
